/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlZeroDayAlertEscalationStatusFilter = {
    ToDo: 'to_do',
    Contacted: 'contacted',
    Fixed: 'fixed',
    Ignored: 'ignored',
    FalsePositive: 'false_positive',
    Unset: 'unset'
} as const;
export type ControlZeroDayAlertEscalationStatusFilter = typeof ControlZeroDayAlertEscalationStatusFilter[keyof typeof ControlZeroDayAlertEscalationStatusFilter];


export function ControlZeroDayAlertEscalationStatusFilterFromJSON(json: any): ControlZeroDayAlertEscalationStatusFilter {
    return ControlZeroDayAlertEscalationStatusFilterFromJSONTyped(json, false);
}

export function ControlZeroDayAlertEscalationStatusFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertEscalationStatusFilter {
    return json as ControlZeroDayAlertEscalationStatusFilter;
}

export function ControlZeroDayAlertEscalationStatusFilterToJSON(value?: ControlZeroDayAlertEscalationStatusFilter | null): any {
    return value as any;
}

